import React, { useState } from "react";
import ReactInputVerificationCode from "react-input-verification-code";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { confirmAccount } from "../../redux/actions/userActionCreators";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const ConfirmAccount = () => {
  const [code, setCode] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const params = useParams();
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <Grid container spacing={4} p={!isMobile && 6} mt={8}>
      <Grid item xs={12}>
        <Typography sx={{ mb: 2 }} variant="title1">
          {t("code_confirmation")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{ mb: 2 }} variant="body1">
          {t("type_code")}
        </Typography>
      </Grid>

      <Grid item xs={12} sx={{ width: isMobile && "100%" }}>
        <Typography sx={{ mb: 2 }} variant="subtitle2">
          {t("code_confirmation")}
        </Typography>
        <div className={isMobile && "confirm_code"}>
          <ReactInputVerificationCode
            value=""
            placeholder=""
            length={6}
            onChange={(newValue) => {
              setCode(newValue);
            }}
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <Button
          style={{ height: "50px", marginTop: !isMobile && "50px" }}
          color="secondary"
          variant="contained"
          fullWidth
          type="submit"
          onClick={() =>
            dispatch(
              confirmAccount(
                { code: Number(code), public_id: params.idAccount },
                history
              )
            )
          }
          disabled={code.length === 6 ? false : true}
        >
          {t("confirm")}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ConfirmAccount;
